<template>
	<div class="newList yxxwDiv">
		<div class="titleBox flexDiv">
			<p>系部新闻</p>
			<a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s">
				<router-link :to="moreLink">查看更多»</router-link>
			</a>
		</div>
		<ul class="newListUl">
			<li v-for="(item,index) in xbxwList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
				<a :href="item.Url">
          <p class="imgBox"><img :src="item.Cover" alt=""></p>
          <div class="flexDiv detail">
            <h1 class="ellipsis">{{item.Title}}</h1>
            <p class="times">
            	<i>{{item.ShowTime2}}</i>
            	<em>{{setTimeformat(item.ShowTime6,'YYYY-mm')}}</em>
            </p>
          </div>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'xbxw',
		props:{
			xbxwList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/xbxw.vue